import Typography from 'typography'
import grandView from 'typography-theme-grand-view'

grandView.headerColor = '#24130d'
grandView.bodyColor = '#2f2725'

const typography = new Typography(grandView)

// hot reload in development
if (process.env.NODE_ENV !== 'production') typography.injectStyles()

export default typography
export const { rhythm, scale, options } = typography

export const media = {
  tablet: '@media only screen and (min-width: 768px)',
  desktop: '@media only screen and (min-width: 1025px)',
  wide: '@media only screen and (min-width: 1369px)',
}

export const color = {
  bg: '#fffffc',
  bgAccent: '#ffffeb',
  header: grandView.headerColor,
  body: grandView.bodyColor,
  accent: '#d65947',
  darkGrey: 'hsl(0, 0%, 35%)',
  lightGrey: 'hsl(0, 0%, 42%)',
  topicBg: '#f5cd25',
  topicBody: '#231f20',
}
